import { render, staticRenderFns } from "./ProductSalesView.vue?vue&type=template&id=fef24bac"
import script from "./ProductSalesView.vue?vue&type=script&lang=js"
export * from "./ProductSalesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports